import type { FC } from "react";
import type { ButtonProps } from "@mui/material";
import { AppButton } from "../../../../shared/components/AppButton";
import styles from "../styles.module.css";
import { getCutName } from "../../helpers";
import { useTranslation } from "react-i18next";

interface Props extends ButtonProps {
	name: string
}

export const RestoreVersionAction: FC<Props> = ({ name, ...props }) => {
  const { t } = useTranslation();

  return (
    <AppButton
      buttonType={"text"}
      className={styles["restore-version-button"]}
      disabled={name === undefined}
      {...props}
    >
      {name ? (getCutName(name, 30)) : `${t("versioning.no_version")}`}
    </AppButton>
  );
};